module.exports = __webpack_public_path__ + "img/imagem-planta-3d-palmeiras.01ff7803.png";